/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  Viewing component
 */

import PropTypes from 'prop-types'
import React from 'react'
import openHouseIconSrc from './svg/openHouseIcon.svg'

const Viewing = ({ theme = {}, viewingText }) => {
  return (
    <div className={theme.viewing}>
      <img alt="" height={12} loading="lazy" src={openHouseIconSrc} width={8} />
      <div className={theme.viewingText}>{viewingText}</div>
    </div>
  )
}

Viewing.propTypes = {
  theme: PropTypes.object,
  viewingText: PropTypes.string,
}

export { Viewing }
